import { Pipe, PipeTransform } from "@angular/core";
import { upperFirst } from "../shared/string-utils";

@Pipe({
    name: "uppercaseFirstLetter",
    standalone: true
})
export class UppercaseFirstLetterPipe implements PipeTransform {
    transform(value?: string): string {
        return upperFirst(value || "");
    }
}
